import {Component, Input, NgModule, OnInit} from '@angular/core';
import {ShipmentStatusService} from '../../../services/shipment-status.service';
import {ShipmentStatus} from '../../../model/shipment-status.enum';
import {ShipmentHistory} from '../../../model/shipment-history.interface';

@Component({
  selector: 'app-statistic-table',
  templateUrl: './statistic-table.component.html',
  styleUrls: ['./statistic-table.component.scss']
})

export class StatisticTableComponent implements OnInit {
  public displayedColumns: string[] = ['consignment_no', 'location', 'status', 'created_at'];
  @Input() shipmentHistory: ShipmentHistory[];
  constructor(public shipmentStatusService: ShipmentStatusService) { }

  ngOnInit() {

  }

  getColorByIndex(statusIndex: number) {
    let status: ShipmentStatus;
    switch (statusIndex) {
      case 0: status = ShipmentStatus.CREATED; break;
      case 1: status = ShipmentStatus.CONFIRMED; break;
      case 2: status = ShipmentStatus.PICKUP; break;
      case 3: status = ShipmentStatus.DELIVERED; break;
      case 4: status = ShipmentStatus.FAILED; break;
    }
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }

  getColorByStatusName(status: string) {
    return this.shipmentStatusService.getColorByStatus(ShipmentStatus[status]);
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/statistic-table/statistic-table.component.ts